import PropTypes from "prop-types";

export default PropTypes.shape({
  suggestion: PropTypes.string,
  highlight: PropTypes.string,
  data: PropTypes.object
});
